import "./TimeLogForm.scss";

import React from "react";
import { Link, Redirect } from "react-router-dom";
import request from "request";
import usesFeatures from "usesFeatures";
import { ApplicationContext } from "ApplicationContext";

import Form from "Form";
import Header from "Header";
import Select from "Select";
import DatePicker from "DatePicker";
import {
  venueTimeZone, tzAbbr, isoToPickerDate, pickerValueToIso,
} from "lib/venue_time_zone";

class TimeLogForm extends React.Component {
  static contextType = ApplicationContext;

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const id = this.props.computedMatch.params.id;
    if (id) {
      this.props.fetchData(`venue_admin/time_logs/${id}/edit`, this.props.seedFormData);
    } else {
      this.props.fetchData("venue_admin/time_logs/new", this.props.seedFormData);
    }
  }

  headerText = () => (this.props.formData.id ? "Edit Time Log" : "New Time Log");

  handleSubmit = (e) => {
    e.preventDefault();

    const { formData } = this.props;
    const id = formData.id;

    // formData.startAt / endAt are already UTC ISO strings — stored that way
    // by the onChange handlers below so re-renders don't lose tz context.
    const payload = {
      time_log: {
        employee_id: formData.employeeId,
        terminal_id: formData.terminalId,
        start_at: formData.startAt || null,
        end_at: formData.endAt || null,
      },
    };

    const method = id ? "patch" : "post";
    const url = id ? `venue_admin/time_logs/${id}` : "venue_admin/time_logs";

    request[method](url, payload).then(({ data }) => {
      if (data.success) {
        this.setState({ saved: true });
      } else {
        this.setState({ errors: data.errors });
      }
    }).catch(({ response }) => {
      this.setState({ errors: (response && response.data && response.data.errors) || ["An error occurred"] });
    });
  };

  handleDelete = () => {
    if (!window.confirm("Delete this time log? This cannot be undone.")) return;
    const id = this.props.formData.id;
    request.delete(`venue_admin/time_logs/${id}`).then(({ data }) => {
      if (data.success) {
        this.setState({ saved: true });
      } else {
        this.setState({ errors: ["Failed to delete time log"] });
      }
    });
  };

  render() {
    if (!this.props.dataFetched) return false;
    if (this.state.saved) return <Redirect to="/time_logs" />;

    const { updateField, formData, employees, terminals } = this.props;

    const employeeOptions = { "": "Select employee..." };
    (employees || []).forEach((e) => { employeeOptions[e.id] = e.name; });

    const terminalOptions = { "": "Select terminal..." };
    (terminals || []).forEach((t) => {
      const storeName = t.store && t.store.name;
      terminalOptions[t.id] = storeName ? `${storeName} — Terminal #${t.number}` : `Terminal #${t.number}`;
    });

    const tz = venueTimeZone(this.context?.CurrentUserContext?.venue);
    const zone = tzAbbr(tz);

    return (
      <div className="TimeLogForm">
        <Header text="Time Logs" backLink="/time_logs" />
        <Form className="block" title={this.headerText()} onSubmit={this.handleSubmit}>
          <Select
            label="Employee"
            onChange={updateField.bind(null, "employeeId")}
            value={formData.employeeId || ""}
            options={employeeOptions}
            required
          />
          <Select
            label="Terminal"
            onChange={updateField.bind(null, "terminalId")}
            value={formData.terminalId || ""}
            options={terminalOptions}
            required
          />
          <DatePicker
            label={`Clock In (${zone})`}
            input_type="datetime"
            value={isoToPickerDate(formData.startAt, tz)}
            onChange={(v) => updateField("startAt", pickerValueToIso(v, tz))}
          />
          <DatePicker
            label={`Clock Out (${zone}) — leave blank for active`}
            input_type="datetime"
            value={isoToPickerDate(formData.endAt, tz)}
            onChange={(v) => updateField("endAt", pickerValueToIso(v, tz))}
          />

          {this.state.errors && (
            <div className="notification is-danger">
              {this.state.errors.map((error, i) => <div key={i}>{error}</div>)}
            </div>
          )}

          <div className="block field is-grouped">
            <p className="control">
              <button onClick={this.handleSubmit} className="button is-primary">
                {formData.id ? "Update" : "Create"} Time Log
              </button>
            </p>
            <p className="control">
              <Link to="/time_logs" className="button">Cancel</Link>
            </p>
            {formData.id && (
              <p className="control ml-auto">
                <button type="button" onClick={this.handleDelete} className="button is-danger is-light">
                  Delete
                </button>
              </p>
            )}
          </div>
        </Form>
      </div>
    );
  }
}

export default usesFeatures(["form", "data"], TimeLogForm);
